import utaCardIcon from '../../assets/images/serviceCardTypes/uta.webp';
import manChargeAndGoCardIcon from '../../assets/images/serviceCardTypes/charge_and_go.webp';
import dkvCardIcon from '../../assets/images/serviceCardTypes/dkv.webp';
import { PaymentPartnerType } from '../../codegen/vehicles';
import { useCustomIntl } from '../../i18n/i18n';
import { SERVICE_CARD_TYPE_TO_TRANSLATION_KEY } from '../../i18n/enumMappings';

type ServiceCardTypeIconProps = {
  type: PaymentPartnerType;
  className: string;
};

const paymentPartnerToIcon: { [key in PaymentPartnerType]: string } = {
  UTA_PAYMENT: utaCardIcon,
  MOCK_FUELING_PAYMENT: manChargeAndGoCardIcon,
  MAN_CHARGE_AND_GO_PAYMENT: manChargeAndGoCardIcon,
  DKV_PAYMENT: dkvCardIcon,
};

export const ServiceCardTypeIcon = ({
  type,
  className,
}: ServiceCardTypeIconProps) => {
  const intl = useCustomIntl();

  return (
    <img
      alt={intl.formatMessage({
        id: SERVICE_CARD_TYPE_TO_TRANSLATION_KEY[type],
      })}
      src={paymentPartnerToIcon[type]}
      className={className}
    />
  );
};
